module.exports = __webpack_public_path__ + "img/mode1-4.f7fe518c.png";